import { useCallback, useRef, useState } from "react";
import { Button, Fab, Input } from "@mui/material";
import Resizer from "react-image-file-resizer";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import HorizontalMenuAtAddPostMedia from "./HorizontalMenuAtAddPostMedia";

import { addDoc, serverTimestamp, collection } from "firebase/firestore";
import { db, auth } from "../api/firebase";

import heic2any from "heic2any"; // ← 追加



const InputMediaOnFeed = ({ photos, setPhotos,setIsPreparingMedia }) => {
  const filePickerRef = useRef(null);

  // const handlePhotoUpload = async (event) => {
  //   const files = event.target.files;

  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];

  //     // ファイルサイズが500KB以上の場合は圧縮
  //     if (file.size > 500 * 1024) {
  //       await resizeImage(file, 500 * 1024, (compressedFile) => {
  //         handlePhotoPreview(compressedFile);
  //       });
  //     } else {
  //       handlePhotoPreview(file);
  //     }
  //   }
  // };

  const logUploadError = async (errorInfo) => {
    try {
      await addDoc(collection(db, "uploadErrors"), {
        userId: auth.currentUser?.uid || "unknown",
        timestamp: serverTimestamp(),
        ...errorInfo,
      });
    } catch (e) {
      console.error("ログ保存失敗", e);
    }
  };

  const handlePhotoUpload = async (event) => {
    const files = event.target.files;
    setIsPreparingMedia(true); // ← 投稿ボタンをロック
  
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
  
      try {
        // .heic の場合は jpeg に変換
        if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9,
          });
  
          file = new File([convertedBlob], file.name.replace(/\.heic/i, ".jpg"), {
            type: "image/jpeg",
          });
        }
  
        // 画像が500KB以上なら圧縮
        if (file.size > 500 * 1024) {
          await resizeImage(file, 500 * 1024, (compressedFile) => {
            handlePhotoPreview(compressedFile);
          });
        } else {
          handlePhotoPreview(file);
        }
      } catch (error) {
        console.error("画像アップロード処理中のエラー:", error);
        await logUploadError({
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          errorMessage: error.message,
          stack: error.stack,
          stage: "handlePhotoUpload",
          userAgent: navigator.userAgent,
        });
      }
    }
  
    setIsPreparingMedia(false); // ← 投稿ボタンをアンロック
  };
  // const handlePhotoPreview = (file) => {
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     const photoData = {
  //       file,
  //       dataURL: event.target.result,
  //       isPosted: false,
  //     };

  //     setPhotos((prevPhotos) => [...prevPhotos, photoData]);
  //   };

  //   reader.readAsDataURL(file);
  // };

  const handlePhotoPreview = async (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const photoData = {
        file,
        dataURL: event.target.result,
        isPosted: false,
      };

      setPhotos((prevPhotos) => [...prevPhotos, photoData]);
    };

    reader.onerror = async (error) => {
      await logUploadError({
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        errorMessage: error.message,
        stage: "reader.onerror",
      });
    };

    try {
      reader.readAsDataURL(file);
    } catch (error) {
      await logUploadError({
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        errorMessage: error.message,
        stage: "reader.readAsDataURL",
      });
    }
  };

  const resizeImage = (file, maxSize, callback) => {
    Resizer.imageFileResizer(
      file,
      maxSize,
      maxSize,
      "JPEG",
      80,
      0,
      (compressedFile) => {
        callback(compressedFile);
      },
      "file"
    );
  };

  const handleDeletePhoto = useCallback(
    (index) => {
      setPhotos((prevPhotos) => {
        const updatedPhotos = [...prevPhotos];
        updatedPhotos.splice(index, 1);
        return updatedPhotos;
      });
    },
    [setPhotos]
  );

  const handlePost = async () => {
    setPhotos([]);
  };

  return (
    <>
      <div className="flex flex-col">
        <div
          onClick={() => filePickerRef.current.click()}
          className="flex space-x-2 justify-center p-2 border cursor-pointer  items-center rounded-md mb-2 w-fit"
        >
          <CameraAltIcon className="h-7 text-green-400" />
          <p className="text-xs sm:text-sm">写真</p>
          <input
            ref={filePickerRef}
            onChange={handlePhotoUpload}
            type="file"
            accept="image/*"
            hidden
            multiple
          />
        </div>
        <div>
          {photos?.length > 0 && (
            <HorizontalMenuAtAddPostMedia
              photos={photos}
              handleDeletePhoto={handleDeletePhoto}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default InputMediaOnFeed;
